import React from "react";
import { useSelector } from "react-redux";
import { Outlet, RouteProps, Navigate, useLocation } from "react-router-dom";
import { ROUTE_LOGIN } from "../constant/routes";
import BaseLayout from "../layouts/BaseLayout/BaseLayout";

const ProtectedRoute = () => {
  const location = useLocation();
  const { isAuthenticated, loading } = useSelector((state) => state.auth);
  // const isAuthenticated = true; // Hardcoded for testing

  return isAuthenticated ? (
    <BaseLayout>
      {/* <Spin spinning={loading} fullscreen /> */}
      <Outlet />
    </BaseLayout>
  ) : (
    <Navigate to={ROUTE_LOGIN} state={{ from: location }} />
  );
};

export default ProtectedRoute;
